<template lang="html">
  <div class="h-screen w-screen bg-white overflow-y-scroll smooth-scroll">
    <div class="mx-auto pt-8 pb-10 text-center">
      <div class="mb-1 flex flex-wrap justify-start mx-auto px-4 container">
      <a href="/" class="border-2 border-gray-500 hover:border-gray-100 text-2xl uppercase  shadow-md hover:bg-gray-900 hover:text-gray-100 text-gray-700 font-bold py-3 px-4 rounded-lg inline-flex items-center">
<svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
</svg>
      <span>Back to Home</span>
      </a>
      </div>
      <br />
      <hr />
  <div class="underline font-semibold text-gray-500 text-5xl py-10">LATEST ARTICLES</div>
<div class="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
    <!--Card 1-->
    <a
    href="/blog/are-time-and-space-the-same-thing" 
    class="flex flex-wrap items-center rounded overflow-hidden shadow-lg border-2 border-gray-100 transition ease-in-out delay-150 hover:-translate-y-3 hover:scale-95 duration-300">
      <img class="w-full" src="../assets/images/blog-1.png" alt="Mountain">
      <div class="px-6 py-4">
        <div class="text-gray-700 font-bold text-3xl mb-2">Are Time and Space the Same Thing</div>
        <p class="text-gray-700 text-md">
          Maybe there is a way to preserve space and time or have infinite space and time. 
          Imagine being able to go anywhere you want without worrying about the distance? 

        </p>
      </div>
    </a>
    <!--Card 2-->
    <a
    href="/blog/how-time-zones-work" 
    class=" flex flex-wrap items-center rounded overflow-hidden shadow-lg border-2 border-gray-100 transition ease-in-out delay-150 hover:-translate-y-3 hover:scale-95 duration-300">
      <img class="w-full" src="../assets/images/blog-2.png" alt="River">
      <div class="px-6 py-4">
        <div class="text-gray-700 font-bold text-3xl mb-2">How Time Zones Work</div>
        <p class="text-gray-700 text-md">
          All clocks show the same time within the world’s 24 time zones. The only difference is that for each zone, the clock is set to show its time in that zone. Not in any other zone.
        </p>
      </div>
    </a>

    <!--Card 3-->
    <a 
    href="/blog/will-time-travel-ever-be-possible"
    class=" flex flex-wrap items-center rounded overflow-hidden shadow-lg border-2 border-gray-100 transition ease-in-out delay-150 hover:-translate-y-3 hover:scale-95 duration-300">
      <img class="w-full" src="../assets/images/blog-3.png" alt="Forest">
      <div class="px-6 pb-6">
        <div class="text-gray-700 font-bold text-3xl mb-2">Will Time Travel Ever Be Possible?</div>
        <p class="text-gray-700 text-md">
          It is a question that may be alluded to in science fiction books, movies, and television shows. Also, there are numerous predictions about when time travel...
        </p>
      </div>
    </a>
<!-- Card 4 -->
    <a
    href="/blog/can-time-go-backward" 
    class=" flex flex-wrap items-center rounded overflow-hidden shadow-lg border-2 border-gray-100 transition ease-in-out delay-150 hover:-translate-y-3 hover:scale-95 duration-300">
      <img class="w-full" src="../assets/images/blog-4.png" alt="Mountain">
      <div class="px-6 py-4">
        <div class="text-gray-700 font-bold text-3xl mb-2">Can Time Go Backward?</div>
        <p class="text-gray-700 text-md">
          Time can always go backward, but that is not the best strategy to avoid the effects of past choices. You may believe that if you travel...
        </p>
      </div>
    </a>

    <!-- Card 5 -->
        <a 
        href="/blog/why-time-management-is-important-for-students"
        class=" flex flex-wrap items-center rounded overflow-hidden shadow-lg border-2 border-gray-100 transition ease-in-out delay-150 hover:-translate-y-3 hover:scale-95 duration-300">
      <img class="w-full" src="../assets/images/blog-5.png" alt="Mountain">
      <div class="px-6 py-4">
        <div class="text-gray-700 font-bold text-3xl mb-2">Why Time Management is Important for Students</div>
        <p class="text-gray-700 text-md">
          Many students are proud of how much time they have for themselves at the end of their school days. That's why it is so easy to feel disheartened when...
        </p>
      </div>
    </a>

  </div>
</div>

    </div>
</template>

<script>
export default {
  name: "Blog",
  title: 'Blog | Big Timer | Fullscreen countdown timer'
}
</script>

<style scoped>
p {
  margin-bottom: 0%;
  color:;
  
}
h1 {
  /* font-size: initial;
  font-weight: unset; */
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue